const welcomePage = {
  "welcome.header": "Elevate Your Game",
  "welcome.subheader": "Improve your soccer performance with insights, analytics and much more on the go.",
};

export const welcome = {
  ...welcomePage,
};
